import { FC, ReactElement } from 'react';
import styles from './toastWithSubheader.module.scss';

interface ToastWithSubheader {
    message: string;
    subMessage: string;
}

export const ToastWithSubHeader: FC<ToastWithSubheader> = ({ message, subMessage }): ReactElement => (
    <div className={styles.holder}>
        <div className={styles.header}>{message}</div>
        <div className={styles.detail}>{subMessage}</div>
    </div>
);
